import React, { useEffect, useState } from "react";
import { CalendarSearch } from "lucide-react";
import api from "../lib/api";

const TR_DAYS = ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"];
const EN_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const FlexibleDates = ({ hotelId, checkIn, checkOut, roomId, roomsCount, adults, mealPlan, customerType, onPick, formatPrice, lang = "tr" }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!hotelId || !checkIn || !checkOut || !roomId) return;
        const tmr = setTimeout(() => {
            api.get(`/hotels/${hotelId}/flexible-prices`, {
                params: {
                    check_in: checkIn, check_out: checkOut, room_id: roomId,
                    rooms_count: roomsCount, adults, meal_plan: mealPlan, customer_type: customerType,
                },
            }).then(({ data }) => setData(data)).catch(() => setData(null));
        }, 350);
        return () => clearTimeout(tmr);
    }, [hotelId, checkIn, checkOut, roomId, roomsCount, adults, mealPlan, customerType]);

    if (!data || (data.options || []).length <= 1) return null;
    const days = lang === "en" ? EN_DAYS : TR_DAYS;
    const fmt = (iso) => {
        const d = new Date(iso + "T00:00:00");
        return `${days[d.getDay()]} ${d.getDate()}.${String(d.getMonth() + 1).padStart(2, "0")}`;
    };
    const allEqual = new Set(data.options.map((o) => o.total)).size === 1;
    const selectedTotal = data.options.find((o) => o.selected)?.total ?? 0;
    const cheaperExists = !allEqual && selectedTotal > Math.min(...data.options.map((o) => o.total));

    return (
        <div data-testid="flexible-dates" className="min-w-0 max-w-full">
            <div className="flex items-center gap-1.5 mb-1.5">
                <CalendarSearch className="w-3 h-3 text-gold" />
                <span className="text-[10px] uppercase tracking-[0.18em] text-gold font-semibold">
                    {lang === "en" ? "Flexible dates (±3 days)" : "Esnek Tarihler (±3 gün)"}
                </span>
                {cheaperExists && (
                    <span className="text-[9px] text-emerald-300">
                        {lang === "en" ? "· cheaper option available" : "· daha uygun tarih var"}
                    </span>
                )}
            </div>
            <div className="flex gap-1.5 overflow-x-auto no-scrollbar pt-2 pb-1">
                {data.options.map((o) => (
                    <button
                        key={o.offset}
                        type="button"
                        onClick={() => onPick({ check_in: o.check_in, check_out: o.check_out })}
                        className={`relative flex-shrink-0 border px-2.5 py-1.5 text-left transition-colors ${
                            o.selected
                                ? "border-gold bg-gold/15 text-gold"
                                : !allEqual && o.is_cheapest
                                ? "border-emerald-400/60 bg-emerald-500/10 text-emerald-300 hover:border-emerald-300"
                                : "border-border_green text-bone/75 hover:border-gold/60"
                        }`}
                        data-testid={`flex-date-${o.offset}`}
                    >
                        <div className="text-[10px] whitespace-nowrap">{fmt(o.check_in)}</div>
                        <div className="text-[11px] font-semibold whitespace-nowrap">{formatPrice(o.total)}</div>
                        {!allEqual && o.is_cheapest && !o.selected && (
                            <div className="absolute -top-1.5 right-1 text-[8px] uppercase tracking-wider bg-emerald-500 text-emerald_deep px-1 font-bold">
                                {lang === "en" ? "Best" : "En Uygun"}
                            </div>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default FlexibleDates;
